module.exports = __webpack_public_path__ + "files/da586018a5f1b55beb343d53bf804007.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Math-Italic.woff
// module id = 1665
// module chunks = 60